<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import { ImageActionService } from './ImageAction.service';
import { ref, watch } from '#imports';

const imageActionService = useService(ImageActionService);



</script>

<template>

</template>
